import { render, staticRenderFns } from "./TipoEnvioEstadoCuentaForm.vue?vue&type=template&id=01bf0611"
import script from "./TipoEnvioEstadoCuentaForm.vue?vue&type=script&lang=ts"
export * from "./TipoEnvioEstadoCuentaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports